import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import NewPatentNumber from './NewPatentNumber';

function NewPatentNumberSearch() {
    const userInfo = useSelector((state) => state.setUserInfo);
    const history = useHistory();

    useEffect(() => {
        if (userInfo !== null && userInfo !== undefined) {
            if (userInfo.kwAccess === false) {
                history.push('/home');
            }
        }
    }, [userInfo, history]);

    return (
        <div>
            <NewPatentNumber />
        </div>
    );
}

export default NewPatentNumberSearch;
